
    import { defineComponent } from 'vue';
    import { PropType } from 'vue';
    import { Offer } from '@/apps/shared/models/offer';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    import checkPricingService from '@/apps/shared/services/checkPricing-service';
    import CRMCotizadorWebService from '@/apps/shared/services/crm-service';
    import discountRangeService from '@/apps/shared/services/getDiscountRange-service';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import getVWHealthGridGroups from '@/apps/shared/services/getVWGridGroups-service';
    import getVWHealthGridCovers from '@/apps/shared/services/getVWGridCovers-service';
    import getHealthQuotation from '@/apps/shared/services/healthQuotation-service';
    import getSafeHealthMaxRequotation from '@/apps/shared/services/getSafeHealthMaxRequotation-service';
    import getCoverCapitalAndDescription from '@/apps/shared/services/getCoverCapitalAndDescription-service';
    import localityService from '@/apps/shared/services/locality-service';
    import WhatsApp from '@/apps/shared/components/WhatsApp.vue';
    import { SaveMultiQuoteNotificationsRequest } from '@/apps/shared/models/saveMultiQuoteNotificationsRequest';

    export default defineComponent({
        name: 'healthMaxPlansSelection-view',
        props: {
            offer: {
                type: Object as PropType<Offer>,
                required: false,
            },
        },
        components: {
            XBreadcrumb,
            WhatsApp,
        },
        data() {
            return {
                group: [],
                groupSelected: {
                    name: ""
                },
                modulesPlan: [],
                premioMensual: null,
                coberturas: [],
                Plandata: [],
                selectedPlan: null,
                finallyCalculationResult: [],
                plans: [],
                col: 2,
                plansLength: 0,
                notCover: null,
                reload: true,
                additionalBenefits: [],
                dataTabHome: null,
                peopleToCover: null,
                breadcrumItems: [
                    { text: 'Inicio', path: '/salud-segura-max' },
                    { text: 'Elegí un Plan', path: '/salud-segura-max/elegiPlan' },
                ],
                leadId: null,
                isOffer: false,
                referente: null,
                medium: null,
                discountRate: null,
                containDiscountRange: null,
                fechaPromotions: null,
                changeTitlePromotions: null,
                sendDataDiscount: {
                    discountRate: null,
                    containDiscountRange: null,
                    changeTitlePromotions: null,
                },
                dataTomador: null,
                cityId: null,
                zipCode: null,
                email: null,
                quotationId: null,
                responseHealth321Quotation: null,
                selectedLocality: null,
                offerVisible: true,
            }
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Salud Segura Max';
                const actualPath = '/salud-segura-max';
                let actualStep = 'quoted';

                if (this.offer) {
                    actualStep = 'stepOffer';
                }

                const request = new SaveMultiQuoteNotificationsRequest();
                request.phone = this.dataTabHome.areaCode + this.dataTabHome.telephone;
                request.mail = this.dataTabHome.email;
                request.quotePlan = this.groupSelected.name;
                request.quotationDetail = "Producto: " + defaultTitle
                    + " - Localidad: " + this.dataTabHome.selectedLocality.text
                    + " - Personas: " + this.peopleToCover;

                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, actualStep, request);
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultSafeHealthMaxGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            removePTags(text) {
                return text.replace(/<\/?p>/g, '');
            },

            extractCoverDescriptions() {
                const descriptions = this.additionalBenefits.map(item => item.coverDescription);
                const lastDescription = descriptions.pop();
                if (descriptions.length === 0) {
                    return lastDescription;
                } else {
                    return descriptions.join(', ') + ' y ' + lastDescription;
                }
            },

            loadAdditionalBenefits() {
                this.additionalBenefits = JSON.parse(sessionStorage.getItem("additionalBenefitsVWHealthGridCovers"));
            },

            selectedPlans: function (quotationData) {
                let pricingId = parseInt(quotationData.pricingId[0])
                quotationData.planDescription = this.groupSelected.name;
                sessionStorage.setItem("selectedPricingId", pricingId.toString());
                sessionStorage.setItem("PlanSelected", JSON.stringify(quotationData));
                sessionStorage.setItem("PlanDescription", JSON.stringify(quotationData.planDescription));
                checkPricingService.checkStatePricing(pricingId).then(response => {
                    if (response.errorMessage == "Actualizacion correcta") {
                        this.$router.push({
                            name: 'healthMaxPolicyOwner-view',
                        })
                    }
                    else {
                        window.globalThis.dataLayer.push({
                            'pas': null,
                            'email': JSON.parse(sessionStorage.getItem("DataTabHome")).email,
                            'product': 'salud',
                            'event': 'errorServidor',
                            'paso': 'cotizador-salud-plan',
                            'referente': this.referente,
                            'medio': this.medium
                        });
                    }
                }).catch(error => {
                    window.globalThis.dataLayer.push({
                        'pas': null,
                        'email': JSON.parse(sessionStorage.getItem("DataTabHome")).email,
                        'product': 'salud',
                        'event': 'errorServidor',
                        'paso': 'cotizador-salud-plan',
                        'referente': this.referente,
                        'medio': this.medium
                    });
                });
            },

            volver() {
                sessionStorage.setItem("pressBack", "true");
                this.$router.push({
                    name: 'healthMaxHome-view',
                })
            },

            openModalDataCoberturas: function (plan) {
                var grid = sessionStorage.getItem("responseGetVWHealthGridCovers");
                var gridJson = JSON.parse(grid);
                let VWGridCovers = gridJson.vwGridCovers;
                let group = parseInt(JSON.parse(sessionStorage.getItem("groupSelected")).id);
                let coversCapitalAndDescription = JSON.parse(sessionStorage.getItem("getHealthCoverCapitalAndDescription-Group" + (group)));

                const filteredItems = VWGridCovers.filter(item => item.gridCategoriesId === 1).map(item => {
                    return {
                        coverDescription: item.coverDescription.trim(),
                        isChecked: item.verticalGroupsId.includes(group),
                        capital: coversCapitalAndDescription.find(cover => cover.coverCode === item.coverNumber).capital
                    };
                });

                this.coberturas = filteredItems;
                this.$refs.modalDataCoberturas.open();
            },

            openModalAdditionalBenefits: function () {
                this.$refs.modalAdditionalBenefits.open();
            },

            closeModalDataCoberturas: function () {
                this.$refs.modalDataCoberturas.close();
            },

            closeModalAdditionalBenefits: function () {
                this.$refs.modalAdditionalBenefits.close();
            },

            dataPlans: function () {
                let planData = sessionStorage.getItem("responseHealth321Quotation");
                let planDataRequotationTemp = sessionStorage.getItem("responseHealth321Requotation");
                let peopleToCover = parseInt(sessionStorage.getItem("peopleToCover"), 10);
                let planDataFinal = peopleToCover === 1 ? planData : planDataRequotationTemp;
                let group = sessionStorage.getItem("responseGetVWHealthGridGroups");

                if (group) {
                    this.group = JSON.parse(group);
                } else {
                    console.error("Group data is not available in sessionStorage.");
                    return;
                }

                if (planDataFinal) {
                    let planDataJson = JSON.parse(planDataFinal);
                    if (planDataJson.hasOwnProperty('plans')) {
                        this.plansLength = planDataJson.plans.length;
                        let planDataOriginal = JSON.parse(planData).plans;
                        this.plans = planDataJson.plans;
                        for (let i = 0; i < this.plans.length; i++) {
                            if (peopleToCover > 1) {
                                this.plans[i].discounts = planDataOriginal[i].discounts;
                            }
                            let pp = this.plans[i].finallyCalculationResult.filter(o => o.detalleInt === 1)[0];
                            this.plans[i].finallyCalculationResult.filter(o => o.detalleInt === 1);
                            Object.assign(this.plans[i], this.modulesPlan[i]);
                            Object.assign(this.plans[i], pp);
                        }
                    } else {
                        console.error("La propiedad 'plans' no está definida en el objeto 'planDataJson'.");
                    }
                } else {
                    console.error("Plan data is not available in sessionStorage.");
                }
            },

            getInitData() {
                sessionStorage.setItem("ExitOrContinueModal", "true");

                NF.UI.Page.block();
                this.leadId = JSON.parse(sessionStorage.getItem("LeadId"));
                this.dataTabHome = JSON.parse(sessionStorage.getItem("DataTabHome"));
                const additionalInformation = {
                    'Localidad': this.dataTabHome.selectedLocality.name,
                    'Personas a cubrir': this.dataTabHome.peopleToCover.toString()
                };
                CRMCotizadorWebService.CreateOrEditLead(
                    this.leadId,
                    this.dataTabHome.email,
                    location.href,
                    this.dataTabHome.areaCode,
                    this.dataTabHome.telephone,
                    321,
                    false,
                    "2",
                    additionalInformation,
                    null,
                    null
                );
                this.peopleToCover = parseInt(sessionStorage.getItem("peopleToCover"), 10);
                if (!isNaN(this.peopleToCover)) {
                    window.globalThis.dataLayer.push({
                        'pas': null,
                        'email': JSON.parse(sessionStorage.getItem("DataTabHome")).email,
                        'product': 'salud',
                        'event': 'cotizador-salud-datos-personales',
                        'personas': (this.peopleToCover?.toString() ?? ''),
                        'referente': this.referente,
                        'medio': this.medium
                    });
                }
                this.groupSelected = this.group.find(item => item.id == (this.peopleToCover > 1 ? 3 : 1));
                if (this.groupSelected) {
                    sessionStorage.setItem("groupSelected", JSON.stringify(this.groupSelected));
                } else {
                    console.error("Group selected not found.");
                }
                this.loadAdditionalBenefits();
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                sessionStorage.removeItem("pressBack");
                NF.UI.Page.unblock();

            },

            InitTabsOffer() {
                const OffersSettings = JSON.parse(this.offer.OffersSettings);

                NF.UI.Page.block({
                    message: [
                        {
                            text: "Estamos buscando tu mejor cotización.",
                            spin: '<i class="fa fa-asterisk fa-spin fa-3x"></i>',
                        },
                        {
                            text: "Aquí viene el segundo mensaje",
                            spin: '<i class="fa fa-circle-o-notch fa-spin fa-3x"></i>',
                        },
                        {
                            text: "Este es el tercer y último mensaje de la serie",
                            spin: '<i class="fa fa-asterisk fa-spin fa-3x"></i>',
                        },
                        //element: "#block-page-panel",
                    ]
                });

                

                this.cityId = OffersSettings.CityId;
                this.zipCode = OffersSettings.Codigo_Postal.toString();
                this.peopleToCover = OffersSettings.peopleToCover;
                this.email = "";

                this.loadLocalityFromCityIdAndQuote();
            },

            async loadLocalityFromCityIdAndQuote() {
                try {
                    this.selectedLocality = {
                        text: "",
                        id: this.cityId,
                        zipCode: this.zipCode,
                        name: "",
                        provinceName: "",
                        localityFormatted: null
                    };

                    await this.cotizarOffer();

                } catch (error) {
                    console.error("Error cargando localidad:", error);

                    this.selectedLocality = {
                        text: "",
                        id: this.cityId,
                        zipCode: this.zipCode,
                        name: "",
                        provinceName: "",
                        localityFormatted: null
                    };

                    try {
                        await this.cotizarOffer();
                    } catch (cotizarError) {
                        NF.UI.Page.unblock();
                        this.Bus.$emit('show-service-fail', 500, [() => this.loadLocalityFromCityId()]);
                    }
                }
            },

            async cotizarOffer() {
                let userName = '';
                let userToken = '';
                let tokenType = "";
                let correlationInformation = "";
                let onDate = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1).toISOString();
                let groupId = this.peopleToCover === 1 ? 1 : 3;

                try {
                    const responseGetVWHealthGridGroups = await getVWHealthGridGroups.getVWHealthGridGroups(
                        321, onDate, correlationInformation, userName, userToken, tokenType
                    );
                    sessionStorage.setItem("responseGetVWHealthGridGroups", JSON.stringify(responseGetVWHealthGridGroups));

                    let coverCodeArray = [1, 2, 3, 4];
                    let coverCode = JSON.stringify(coverCodeArray);

                    const coverPromises = responseGetVWHealthGridGroups
                        .filter(item => item.id == groupId)
                        .map(item => {
                            const coverPercent = item.coverPercent;
                            const id = item.id;
                            return getCoverCapitalAndDescription.getHealthCoverCapitalAndDescription(
                                321, coverPercent, 0, onDate, coverCode, 1,
                                correlationInformation, userName, userToken, tokenType
                            ).then(responseGetHealthCoverCapitalAndDescription => {
                                sessionStorage.setItem(
                                    "getHealthCoverCapitalAndDescription-Group" + id,
                                    JSON.stringify(responseGetHealthCoverCapitalAndDescription)
                                );
                            });
                        });

                    const additionalCoveragePromise = getVWHealthGridCovers.getVWHealthGridCovers(
                        321, onDate, 1, null, correlationInformation, userName, userToken, tokenType
                    ).then(responseGetVWHealthGridCovers => {
                        sessionStorage.setItem("responseGetVWHealthGridCovers", JSON.stringify(responseGetVWHealthGridCovers));

                        let additionalBenefits = responseGetVWHealthGridCovers.vwGridCovers
                            .filter(cover => cover.gridCategoriesId === 2)
                            .map(item => ({
                                coverDescription: item.coverDescription.trim(),
                                isChecked: item.verticalGroupsId.includes(groupId),
                                coverDescriptionTooltip: item.coverDescriptionTooltip?.trim() ?? "",
                            }));
                        sessionStorage.setItem("additionalBenefitsVWHealthGridCovers", JSON.stringify(additionalBenefits));
                    });

                    await Promise.all([...coverPromises, additionalCoveragePromise]);

                    let body = JSON.stringify({
                        userName: userName,
                        userToken: userToken,
                        tokenType: tokenType,
                        correlationInformation: correlationInformation,
                        cityId: parseInt(this.cityId),
                        zipCode: this.zipCode,
                        peopleToCover: this.peopleToCover
                    });

                    const responseHealth321Quotation = await getHealthQuotation.createHealth321Quotation(body);
                    sessionStorage.setItem("responseHealth321Quotation", JSON.stringify(responseHealth321Quotation));
                    this.quotationId = responseHealth321Quotation.plans[0].quotationId;
                    this.responseHealth321Quotation = responseHealth321Quotation;

                    if (this.peopleToCover > 1) {
                        const requotationResult = await getSafeHealthMaxRequotation.getSafeHealthMaxRequotation(
                            this.peopleToCover, this.quotationId
                        );
                        if (requotationResult) {
                            sessionStorage.setItem("responseHealth321Requotation", JSON.stringify(requotationResult));
                        }
                    }

                    this.dataTomador = {
                        areaCode: "",
                        telephone: "",
                        email: this.email,
                        cityId: this.cityId,
                        cityName: this.selectedLocality.name,
                        zipCode: this.zipCode,
                        selectedLocality: this.selectedLocality,
                        peopleToCover: this.peopleToCover,
                    };
                    sessionStorage.setItem("DataTabHome", JSON.stringify(this.dataTomador));
                    sessionStorage.setItem("peopleToCover", this.peopleToCover.toString());

                    if (this.responseHealth321Quotation != null) {
                        const leadResponse = await CRMCotizadorWebService.CreateOrEditLead(
                            this.leadId, this.email, location.href, null, null, 321, false, "1", null, null, null
                        );
                        sessionStorage.setItem("LeadId", JSON.stringify(leadResponse));
                        this.leadId = leadResponse;
                    }

                    this.dataTabHome = this.dataTomador;
                    this.group = responseGetVWHealthGridGroups;
                    this.groupSelected = this.group.find(item => item.id == groupId);
                    sessionStorage.setItem("groupSelected", JSON.stringify(this.groupSelected));

                    this.loadAdditionalBenefits();
                    this.dataPlans();

                    this.offerVisible = true;
                    NF.UI.Page.unblock();

                } catch (error) {
                    NF.UI.Page.unblock();
                    let statusCode = null;

                    if (error.response && error.response.status) {
                        statusCode = error.response.status;
                    } else if (error.message === '204') {
                        statusCode = 204;
                    }

                    console.error("Error en la ejecución de cotización offer:", error);

                    window.globalThis.dataLayer.push({
                        'pas': null,
                        'email': this.email,
                        'product': 'salud',
                        'event': 'errorUsuario',
                        'paso': 'cotizador-salud-offer',
                        'referente': this.referente,
                        'medio': this.medium
                    });

                    this.Bus.$emit('show-service-fail', statusCode, [() => this.cotizarOffer()]);
                }
            },

            async getSafeHealthMaxDiscountRange() {
                await discountRangeService.getSafeHealthMaxDiscountRange().then((response) => {
                    this.containDiscountRange = response.length > 0;
                    if (this.containDiscountRange) {
                        this.responseDiscountRange = response;
                        sessionStorage.setItem("thereIsDiscount", "true");
                        this.discountRate = parseInt(this.responseDiscountRange[0].discountMaxValue, 10);
                        this.fechaPromotions = new Date();
                        var FechaInicioEvento = new Date(Date.parse("05/15/2025"));
                        var FechaFinEvento = new Date(Date.parse("05/18/2025"));
                        this.changeTitlePromotions = (this.fechaPromotions >= FechaInicioEvento && this.fechaPromotions <= FechaFinEvento);
                        this.sendDataDiscount = {
                            discountRate: this.discountRate,
                            containDiscountRange: this.containDiscountRange,
                            changeTitlePromotions: this.changeTitlePromotions,
                        };
                        if (this.$refs.titlesAndPromotions) {
                            this.$refs.titlesAndPromotions.setDiscountData(this.sendDataDiscount);
                        }
                    } else {
                        sessionStorage.setItem("thereIsDiscount", "false");
                        this.containDiscountRange = false;
                    }                
                });
            },
        },

        async mounted() {
            try {              

                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente;
                var medium = sessionStorage.getItem("Medium");
                medium == 'null' || medium == null ? this.medium = 'organic' : this.medium = medium;

                if (this.offer) {
                    // FLUJO OFFER
                    this.offerVisible = false;
                    const rutaAlternativa = sessionStorage.getItem("rutaAlternativa");
                    sessionStorage.clear();
                    sessionStorage.setItem("rutaAlternativa", rutaAlternativa);
                    sessionStorage.setItem("Referente", this.referente);
                    sessionStorage.setItem("Medium", this.medium);

                    this.dataTabHome = {
                        firstname: "aaa",
                        lastname: "bbb",
                        areaCode: "",
                        telephone: "",
                        email: "",
                        selectedLocality: {
                            text: "",
                        }
                    };

                    this.isOffer = true;
                   
                    await this.pageCustomization();                  
                    await this.getSafeHealthMaxDiscountRange();
                    await this.InitTabsOffer();
                   
                    this.updateByProductGoogleAnalytics();
                }
                else {
                    NF.UI.Page.block();
                    const parallelPromises = [
                        this.updateByProductGoogleAnalytics(),
                        this.dataPlans(),
                    ];

                    await Promise.all([...parallelPromises]);

                    await this.getInitData();
                    await this.pageCustomization();
                }

            } catch {
                NF.UI.Page.unblock();
            }
        },
    })
